var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bl_area capture_area" },
    [
      _c(
        "form",
        {
          attrs: { id: "frm_container" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("h2", { staticClass: "content_title" }, [
            _vm._v("B/L Body Detail"),
          ]),
          _c("table", { staticClass: "tbl_col mt10 tbl_mark" }, [
            _vm._m(0),
            _c("thead", [
              _c("tr", [
                _c("th", { staticClass: "text_left" }, [_vm._v(" Mark & No ")]),
                _c("th"),
                _c("th", [
                  _c(
                    "button",
                    {
                      staticClass: "tbl_icon plus",
                      on: { click: _vm.addMarkDesc },
                    },
                    [_vm._v(" plus ")]
                  ),
                ]),
              ]),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.regParams.houseBlDescList, function (vo, idx) {
                return _c("tr", { key: "markDesc_" + idx }, [
                  _c(
                    "td",
                    { staticClass: "td_mrk" },
                    [
                      _c("ETextarea2", {
                        attrs: {
                          id: "mrk_" + idx,
                          "max-line": 18,
                          "column-length": 25,
                          value: vo.mrk,
                          "is-upper": true,
                          "padding-right": 223,
                        },
                        model: {
                          value: vo.mrk,
                          callback: function ($$v) {
                            _vm.$set(vo, "mrk", $$v)
                          },
                          expression: "vo.mrk",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "td_desc" },
                    [
                      _c("ETextarea2", {
                        staticClass: "txt_dscr",
                        attrs: {
                          id: "dscr_" + idx,
                          "max-line": 18,
                          "column-length": 45,
                          "is-upper": true,
                          value: vo.dscr,
                          "padding-right": 383,
                        },
                        model: {
                          value: vo.dscr,
                          callback: function ($$v) {
                            _vm.$set(vo, "dscr", $$v)
                          },
                          expression: "vo.dscr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("td", [
                    idx !== 0
                      ? _c(
                          "button",
                          {
                            staticClass: "tbl_icon minus",
                            on: {
                              click: function ($event) {
                                return _vm.removeMarkDesc(idx)
                              },
                            },
                          },
                          [_vm._v(" minus ")]
                        )
                      : _vm._e(),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
      _c(
        "win-layer-pop",
        [
          _vm.customComponent
            ? _c(_vm.customComponent, {
                tag: "component",
                attrs: { "parent-info": _vm.popParams },
                on: {
                  close: _vm.closePopup,
                  selectFunc: _vm.selectFunc,
                  child: _vm.getChildData,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.commonBLComponent
        ? _c(_vm.commonBLComponent, {
            ref: "commonBL",
            tag: "component",
            attrs: { "parent-info": _vm.commonBLParams },
            on: { callback: _vm.commonBLCallback },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "41%" } }),
      _c("col", { attrs: { width: "56%" } }),
      _c("col", { attrs: { width: "3%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }